import { getDocFromServer } from 'firebase/firestore';

/** Shown when the server removes the new deck after create (free monthly cookbook cap). */
export const cookbookDeckRemovedByMonthlyLimitMessage =
  'This cookbook was not saved: you have reached the free limit for new cookbooks this month (UTC). Upgrade to Pro for unlimited cookbooks.';

/**
 * After `addDoc` on `users/{uid}/decks/{deckId}`, `enforceLibraryCookbookLimit` may delete the
 * document. The client write still "succeeds", so we poll the server to surface that outcome in the UI.
 *
 * @param {import('firebase/firestore').DocumentReference} deckRef
 * @param {{ timeoutMs?: number, pollMs?: number }} [options]
 * @returns {Promise<{ ok: true } | { ok: false, removedByMonthlyLimit: boolean }>}
 */
export async function confirmCookbookDeckNotRemovedByQuotaTrigger(deckRef, options = {}) {
  const timeoutMs = options.timeoutMs ?? 15000;
  const pollMs = options.pollMs ?? 400;
  const deadline = Date.now() + timeoutMs;
  let seenExisting = false;

  while (Date.now() < deadline) {
    try {
      const snap = await getDocFromServer(deckRef);
      if (snap.exists()) {
        seenExisting = true;
      } else if (seenExisting) {
        return { ok: false, removedByMonthlyLimit: true };
      }
    } catch {
      // transient / offline
    }
    await new Promise((r) => setTimeout(r, pollMs));
  }

  try {
    const final = await getDocFromServer(deckRef);
    if (final.exists()) {
      return { ok: true };
    }
    if (seenExisting) {
      return { ok: false, removedByMonthlyLimit: true };
    }
    return { ok: false, removedByMonthlyLimit: true };
  } catch {
    return { ok: true };
  }
}
